// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const PaginatorFirst = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2" d="M19 1L9 12l10 11" /><path fill="currentColor" stroke="transparent" d="M6 1c0-.5523-.4477-1-1-1S4 .4477 4 1h2zM4 23c0 .5523.4477 1 1 1s1-.4477 1-1H4zM4 1v22h2V1H4z" /></React.Fragment>, },
  'default'
);
